import { IPageState } from "@rhc-shared-components/table-toolbar/dist/models/GeneralModels";

export const InitialPaginationValue: IPageState = {
  page: 1,
  perPage: 250
};
